import { utils } from '@hh/global.js'

const { debounce } = utils

class ProductRecommendations extends HTMLElement {
  constructor() {
    super()

    this.stickyWrapper = document.querySelector('[data-sticky-wrapper]')
    this.debouncedResize = debounce(() => {
      this.calcStickyOffset()
    }, 0).bind(this)

    this.fetchRecommendations()
  }

  connectedCallback() {
    window.addEventListener('resize', this.debouncedResize)
  }

  fetchRecommendations() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div')
        html.innerHTML = text
        const recommendations = html.querySelector('product-recommendations')
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }

  calcStickyOffset() {
    const isMobile = window.matchMedia('(max-width: 989px)').matches
    this.stickyWrapper.style.paddingBottom = isMobile
      ? '0px'
      : `${this.offsetHeight}px`
  }
}

customElements.define('product-recommendations', ProductRecommendations)
